<div id="welcome" class="welcome-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">

            <h2>{{ 'welcome.title' | translate }} <span>{{ 'welcome.highlight' | translate }}</span></h2>
            <p>{{ 'welcome.subtitle' | translate }}</p>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <!--<i class="far fa-edit"></i>-->
                        <img src="assets/images/demo/iconos_Innovacion_tecnologica.png">
                    </div>
                    <h3>{{ 'welcome.innovationTitle' | translate }}</h3>
                    <p>{{ 'welcome.innovationText' | translate }}</p>
                    <a (click)="onClick('about')" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa fa-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <!--<i class="fas fa-laptop"></i>-->
                        <img src="assets/images/demo/icono_sustentabilidad.png">
                    </div>
                    <h3>{{ 'welcome.sustainabilityTitle' | translate }}</h3>
                    <p>{{ 'welcome.sustainabilityText' | translate }}</p>
                    <a (click)="onClick('about')" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa fa-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <!--<i class="far fa-life-ring"></i>-->
                        <img src="assets/images/demo/iconos_Atencion_personalizada.png">
                    </div>
                    <h3>{{ 'welcome.attentionTitle' | translate }}</h3>
                    <p>{{ 'welcome.attentionText' | translate }}</p>
                    <a (click)="onClick('about')" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa fa-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
    <div class="shape2"><img src="assets/img/shape1.png" alt="image"></div>
</div>
